export default "__VITE_ASSET__89ab3eb6__"